module.exports = __webpack_public_path__ + "static/img/splj_pic4.1.95f4dd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/videounderstand/splj_pic4.1.jpg
// module id = 8Zof
// module chunks = 0